import {
  getAllModulesInitActions,
  getSectionLayoutInitAction,
  getModuleData,
  getPageInfoInitActions,
} from './common';
import { ModuleType } from '../../../types/modules';
import { SubscriptionsTierContentType } from '../../../types/subscriptionsSection';
import {
  setSelectedTierId,
  setSelectedTierContentType,
} from '../../actions/subscriptionsSection';
import { setTotalPages } from '../../actions/pageInfo';

export function getSubscriptionsSectionInitActions(
  responseData,
  requestParams
) {
  const { tierDeviationid, totalPageCount = 1 } =
    getModuleData(responseData.sectionData.modules, ModuleType.TIER_CONTENT) ||
    {};
  return [
    setSelectedTierId(tierDeviationid),
    setSelectedTierContentType(
      requestParams.section || SubscriptionsTierContentType.DEVIATIONS
    ) /* TODO: Update TIERS_CONTENT module to return content type in PAPI */,
    setTotalPages(totalPageCount),
    getSectionLayoutInitAction(responseData, 'subscriptions'),
    ...getAllModulesInitActions(responseData, requestParams),
    ...getPageInfoInitActions(responseData, requestParams),
  ].filter(action => action);
}
